import React from 'react';
import { Bell } from 'lucide-react';

const Header = () => {
  return (
    <header className="bg-white shadow-sm">
      <div className="container-fluid px-4 py-3">
        <div className="d-flex justify-content-between align-items-center">
          <h1 className="h3 mb-0">OVLM - Espace Admin</h1>
          <div>
            {/* <button className="btn btn-light rounded-circle">
              <Bell size={20} />
            </button> */}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;